import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { Endpoint } from '@/Config/api/endpoint';
import { SocketKey } from '@/Config/api/socketKey';
import { ConversationDto } from '@/Domain/api/Conversation/dto/Conversation.dto';
import { useSocket } from '@/Domain/components/SocketProvider';

export const useChangeStatus = (id: string) => {
  const queryClient = useQueryClient();
  const { socket } = useSocket();

  useEffect(() => {
    socket.on(
      SocketKey.conversation.statusChanged,
      ({ event, conversation_id: conversationId }) => {
        if (conversationId === id) {
          queryClient.setQueryData(
            [Endpoint.conversation.get, conversationId],
            (prevData: ConversationDto) => {
              if (prevData) {
                return {
                  ...prevData,
                  resolution_status: event.data.resolution_status,
                };
              }

              return undefined;
            },
          );
        } else {
          queryClient
            .invalidateQueries({ queryKey: ['conversations', conversationId, 'events'] })
            .catch(() => null);
        }
      },
    );
    return () => {
      socket.off(SocketKey.conversation.statusChanged);
    };
  }, [id, socket]);
};
